import type { CheckpointRolloutRow } from "../data/checkpoint-rollout";
import {
  ACTIVE_MATERIAL_INVENTORY_NOTE,
  formatActiveMaterialInventory,
  hasDuplicateActiveMaterial,
} from "../data/checkpoint-material";

export function ActiveMaterialInventory({
  rows,
}: {
  rows: CheckpointRolloutRow[];
}) {
  const withMaterial = rows
    .filter((row) => row.hasCheckpointMaterial)
    .sort((left, right) => left.checkpointName.localeCompare(right.checkpointName));

  if (withMaterial.length === 0) {
    return null;
  }

  return (
    <section className="minter__inventory" aria-label="Active checkpoint material inventory">
      <h3 className="minter__section-title">Active checkpoint material</h3>
      <p className="minter__section-copy">{ACTIVE_MATERIAL_INVENTORY_NOTE}</p>
      <ul className="minter__inventory-list">
        {withMaterial.map((row) => (
          <li key={row.checkpointId || row.checkpointName} className="minter__inventory-item">
            <div className="minter__inventory-main">
              <span className="minter__inventory-name">{row.checkpointName}</span>
              <span className="minter__inventory-where">
                {[row.routeName, row.siteName].filter(Boolean).join(" · ") || "No route"}
              </span>
            </div>
            <div className="minter__inventory-meta">
              <span className="minter__inventory-count">{formatActiveMaterialInventory(row)}</span>
              {hasDuplicateActiveMaterial(row) ? (
                <span className="minter__inventory-warn" role="status">
                  Multiple active secrets — use Replace to consolidate to one tag.
                </span>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ActiveMaterialBadge({
  row,
}: {
  row: Pick<
    CheckpointRolloutRow,
    "activeQrTokens" | "activeNfcTokens" | "activeCheckpointMaterial" | "hasCheckpointMaterial"
  >;
}) {
  if (!row.hasCheckpointMaterial) {
    return <span className="materialverify__inventory materialverify__inventory--empty">On file: none</span>;
  }

  return (
    <span className="materialverify__inventory">
      On file: {formatActiveMaterialInventory(row)}
      {hasDuplicateActiveMaterial(row) ? " · multiple secrets" : ""}
    </span>
  );
}
